<style lang="scss" scoped>
.t_container::-webkit-scrollbar {
  width: 0 !important;
}

.t_container {
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0 20px 20px 20px;

  .header {
    .top {}

    .conditions {
      .line {
        background: #e4e7ed;
        width: 100%;
        height: 1px;
        margin-top: -10px;
      }
    }

    .top2 {
      margin-top: 12px;
    }

    .buttons {
      margin-top: 12px;
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;

      .buttonsL {
        display: flex;
      }

      .buttonsR {
        flex-shrink: 0;
        display: flex;
      }
    }
  }

  .footer {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }

  .footer2 {
    display: flex;
    justify-content: space-between;
  }
}
</style>
<style lang="scss">
.hideFormItem {
  display: none !important;
}

.el-transfer-panel__item.el-checkbox {
  margin-right: 0;
}

.genFromComponent.el-form--inline .fieldGroupWrap {
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}

.genFromComponent.el-form--inline .validateWidget {
  margin-right: 0;
}

.curd-table {
  .el-table {
    border-color: #ebeef5 !important;
  }
}
</style>
<template>
  <div class="t_container" ref="container">
    <div class="header" ref="header">
      <div id="top" ref="top" class="top">
        <slot name="top"> </slot>
      </div>
      <div v-if="isShowCondition" id="conditions" ref="conditions" class="conditions">
        <slot name="conditions"> </slot>
        <!-- <slot name="searchExpand">
					<el-button>{{$t('chongzhi')}}</el-button>
				</slot> -->
        <div class="line"></div>
      </div>
      <div v-if="isShowTop2" id="top2" ref="top2" class="top2">
        <slot name="top2"> </slot>
      </div>

      <div ref="buttons" class="buttons" v-if="ids == null || isShowButtons">
        <div>
          <slot name="buttonsL"></slot>
        </div>
        <div>
          <slot name="buttonsR"></slot>
        </div>
      </div>
    </div>
    <div class="curd-table" ref="curd_table">
      <el-table ref="table" :lazy="lazy" :load="load" :row-style="{ height: 42 + 'px' }" :cell-style="{ padding: 0 + 'px' }" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" stripe :row-key="rowKey" :default-expand-all="defaultExpandAll" :expand-row-keys="expandRowKeys" @expand-change="$emit('expandChange', $event)" :tree-props="{ children: 'children' }" :id="randKey" :key="randKey" :data="list" style="width: 100%" highlight-current-row border size="medium" v-loading="loading" :max-height="tableHeight" @current-change="$emit('currentChange')" @row-click="rowClick" @selection-change="selectionChange" @select="select" @select-all="selectAll" @sort-change="changeTableSort" :show-summary="isShowSummary" :summary-method="getSummaries" @header-dragend="headerDragend">
        <!-- 选择列 -->
        <!-- && (scope.row.children != null || (scope.row.children == null && isShowChildSelection == false)) -->
        <el-table-column v-if="ids != null" type="selection" width="50" :align="'center'" :selectable="selectable"> </el-table-column>
        <el-table-column v-if="isExpand" type="expand">
          <template slot-scope="scope">
            <slot :row="scope.row" name="expand"></slot>
          </template>
        </el-table-column>

        <template v-for="(col, index) in generateTableColumns" v-if="(fixShowColumns.length > 0 ? generateFixShowColumns.indexOf(col.label) != -1 : showColumns.indexOf(col.label) != -1) && !(col.type == 'slot' && col.label == 'caozuo' && (ids != null && !isShowCaoZuo)) && (col.show !== false)">
          <!-- :prop="'asdfasdf'" 利用这个做sortbale-->
          <!-- <template v-if="col.type == 'selection'">
            <el-table-column v-if="ids == null " type="selection" width="50" :align="'center'"> </el-table-column>
          </template> -->




          <template v-if="col.type == 'selection'">
            <el-table-column v-if="ids == null" type="selection" width="50" :align="'center'" :selectable="col.selectable ? col.selectable : selectable"> </el-table-column>
          </template>
          <!-- <el-checkbox :value="isSelected(scope.row[SELECT_ID])"
						@change="isSelected(scope.row[SELECT_ID])?deleteItem(scope.row):getItem(scope.row)">
					</el-checkbox> -->
          <!-- 索引列 -->
          <el-table-column v-else-if="col.type == 'index'" :prop="col.prop" :label="$t(col.label ? col.label : '#')" type="index" :width="col.width != null ? col.width : 50" :align="col.align ? col.align : 'center'" :fixed="col.fixed" :render-header="col.isStar ? addRedStar : null">
            <template slot-scope="scope">
              <span :style="{ color: col.color }">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column v-else-if="col.type == 'header'" :label="$t(col.label)" :width="col.width" :align="col.align ? col.align : 'center'" :fixed="col.fixed" :render-header="col.isStar ? addRedStar : null">
            <el-table-column v-for="subCol in col.subCols" :prop="subCol.prop" :label="$t(subCol.label ? subCol.label : '#')" :width="subCol.width != null ? subCol.width : 50" :align="subCol.align ? subCol.align : 'center'">
              <template slot-scope="scope">
                <slot v-if="subCol.type == 'slot'" :row="scope.row" :_index="scope.$index" :name="subCol.label"></slot>
                <span v-else>{{ utils.getObjValueByLevelString(scope.row, subCol.prop) }}</span>
              </template>
            </el-table-column>

          </el-table-column>



          <el-table-column :sortable="col.sort != null" :sort-method="sortMethod(col)" :show-overflow-tooltip="!col.wrap && col.label != 'caozuo'" :ref="col.prop" v-else :prop="col.prop" :label="$t(col.label)" :width="col.width" :align="col.align ? col.align : 'left'" :fixed="col.fixed" :render-header="col.isStar ? addRedStar : null">
            <template slot-scope="scope">
              <span v-if="col.formatter" :style="{ color: col.color }">{{ col.formatter(scope) }}</span>
              <el-tag v-else-if="col.type == 'tag' && utils.getObjValueByLevelString(scope.row, col.prop) != null && utils.getObjValueByLevelString(scope.row, col.prop) !== ''" effect="light" size="small" :style="{
                color: col.tags[utils.getObjValueByLevelString(scope.row, col.prop) + ''].color,
                'background-color': col.tags[utils.getObjValueByLevelString(scope.row, col.prop) + ''].color + '10',
                border: 'none'
              }" :color="col.tags[utils.getObjValueByLevelString(scope.row, col.prop) + ''].color">
                {{ col.tags[utils.getObjValueByLevelString(scope.row, col.prop) + ''].text }}
              </el-tag>
              <el-tag v-else-if="col.type == 'dictionary_tag' && utils.getObjValueByLevelString(scope.row, col.prop) != null && utils.getObjValueByLevelString(scope.row, col.prop) !== ''" effect="light" size="small" :style="{
                color: generateDictionayColorOne(col.key, scope.row, col.prop),
                'background-color': generateDictionayColorOne(col.key, scope.row, col.prop) + '10',
                border: 'none'
              }" :color="generateDictionayColorOne(col.key, scope.row, col.prop)">
                {{ generateDictionayValueOne(col.key, scope.row, col.prop) }}
              </el-tag>
              <span v-else-if="col.type == 'time'" :style="{ color: col.color }">
                {{ utils.getObjValueByLevelString(scope.row, col.prop) && dayjs(utils.getObjValueByLevelString(scope.row, col.prop)).format(col.format ? col.format : 'YYYY-MM-DD HH:mm:ss') }}
              </span>
              <slot v-else-if="col.type == 'slot'" :row="scope.row" :_index="scope.$index" :name="col.label"></slot>
              <el-link v-else-if="col.type == 'link'" target="_blank" :href="utils.getObjValueByLevelString(scope.row, col.prop)" type="primary" :style="{ color: col.color }">{{ utils.getObjValueByLevelString(scope.row, col.prop) }} </el-link>
              <span v-else-if="col.type == 'bool'" :style="{ color: col.color }">
                {{ utils.getObjValueByLevelString(scope.row, col.prop) == true || utils.getObjValueByLevelString(scope.row, col.prop) == 1 ? $t(col.iln18 ? col.iln18[0] : 'shi') : $t(col.iln18 ? col.iln18[1] : 'fou') }}
              </span>
              <span v-else-if="col.type == 'dictionary'" :style="{ color: col.color }">
                {{ generateDictionayValues(col.key, scope.row, col.prop) }}
              </span>

              <p v-else-if="col.type == 'textarea'" style="white-space: pre-line;" :style="{ color: col.color }">
                <readmore @fold="textareaFold" :data="utils.getObjValueByLevelString(scope.row, col.prop)" :maxLen="isExportExcelt ? 10000 : 40"></readmore>
              </p>
              <span v-else-if="col.type == 'price'" :style="{ color: col.color }">
                {{ utils.getObjValueByLevelString(scope.row, col.prop) | fenToYuan }}
              </span>
              <!--.sync不能用方法，因为这里只是查看，所以不用sync没问题-->
              <normal_upload v-else-if="col.type == 'file'" :files="utils.getObjValueByLevelString(scope.row, col.prop)" :read_only="true"> </normal_upload>

              <span v-else :style="{ color: col.color }">{{ utils.getObjValueByLevelString(scope.row, col.prop) }} </span>
            </template>
          </el-table-column>
        </template>
        <!-- <el-table-column v-if="ids != null" :label="$t('xuanze')" width="100" :align="'center'" :fixed="'left'">
					<template slot-scope="scope">
						<el-checkbox :value="isSelected(scope.row[SELECT_ID])"
							@change="isSelected(scope.row[SELECT_ID])?deleteItem(scope.row):getItem(scope.row)">
						</el-checkbox>
						
					</template>
				</el-table-column> -->
      </el-table>

      <div ref="footer">
        <div class="footer">
          <slot :name="'footer'">&nbsp</slot>
          <div v-show="total > 0 && isShowPagination">
            <el-pagination background layout="total,sizes,prev, pager, next" @current-change="get" @size-change="sizeChange" :page-sizes="pageSizes" :current-page.sycn="pageNum" :total="total" :page-size.sycn="pageSize"></el-pagination>
          </div>
        </div>
        <div class="footer2">
          <slot :name="'footer_bottom'">&nbsp</slot>
        </div>
      </div>
    </div>

    <el-dialog :show-close="true" :title="$t('peizhixianshilie')" :visible.sync="isShowColumnsDialog" :close-on-click-modal="false" width="720px" :before-close="closeColumnsDialog" append-to-body>
      <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
        <el-transfer ref="transfer" target-order="push" style="text-align: left; display: inline-block" v-model="showColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{
          noChecked: '${total}',
          hasChecked: '${checked}/${total}'
        }" @change="showColumnsChange" :data="generateTransferColumns">
          <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;" @dragstart="drag($event, option)" :class="option.label == 'xuanze' ? 'ignore-elements' : null">
            <div>{{ $t(option.label) }}</div>
            <div>
              <!-- <i @click="columnUp($event,option.label)" class="el-icon-bottom" style="font-size: 14px;"></i> -->
            </div>
          </div>
        </el-transfer>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs';
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
  name: 'yi_curd_table',
  props: {
    //标明来自哪里，用于判断各种逻辑
    name: null,
    pageSizes: {
      type: Array,
      default: function () {
        return [10, 20, 50, 100, 500];
      }
    },
    lazy: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: ''
    },
    load: {
      type: Function
    },

    fixConditions: {
      type: Object,
      default: function () {
        return {};
      }
    },
    fixEditObj: {
      type: Object,
      default: function () {
        return {};
      }
    },
    //外部传入固定的组件高度
    fixContainerHeight: {
      type: Number,
      default: 0
    },
    //外部传入固定的组件高度
    fixShowColumns: {
      type: Array,
      default: function () {
        return [];
      }
    },
    ids: {},
    //ids的max
    max: {
      type: Number,
      default: 999
    },
    //是否显示按钮栏
    isShowButtons: {
      type: Boolean,
      default: true
    },
    //是否显示操作栏
    isShowCaoZuo: {
      type: Boolean,
      default: true
    },
    isShowCondition: {
      type: Boolean,
      default: true
    },
    isShowTop2: {
      type: Boolean,
      default: true
    },

    getUrl: {
      type: String,
      default: ''
    },
    getKey: {
      type: String,
      default: 'rows'
    },
    isRandKey: {
      type: Boolean,
      default: true
    },
    isFromHiddenCrossSelect: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      }
    },
    isExpand: {
      type: Boolean,
      default: false
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    expandRowKeys: {
      type: Array,
      default: function () {
        return [];
      }
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    isShowChildSelection: {
      type: Boolean,
      default: true
    },
    isSetTableHeightAuto: {
      type: Boolean,
      default: false
    },


  },
  data() {
    return {
      SELECT_ID: '',
      SELECT_TITLE: '',
      SELECT_URL: '',
      SELECT_RESULT_KEY: '',
      isExportExcelt: false,
      conditions: {},
      isShowSummary: false,
      exportLoading: false,
      loading: false,
      tableHeight: 0,
      randKey: 't' + new Date().valueOf(),
      list: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      isShowEditDialog: false,
      editObj: {
        loading: false
      },
      datas: {}, //用来存放接口返回的变量
      dialogWidth: 0,
      dialogWidths: {},
      formLabelWidth: 0,
      formLabelWidths: {},
      //下面是有关列和配置
      isShowColumnsDialog: false,
      showColumns: [],
      draggingKey: '',
      //展开列
      expands: [],
      //搜索栏是否隐藏
      isSearchNeedHide: false,
      isSearchHidden: true,
      //是否显示分页
      isShowPagination: true,
      //用来触发改变列宽的computed的
      aaa: true
    };
  },

  created() {
    if (!this.name) {
      alert(this.$t('biaogemingchengweikong'));
      return;
    }

    //把客制化Columns的加上
    let fieldsJson = null;
    for (let index = 0; index < this.store.state.customerTableFields.length; index++) {
      if (this.store.state.customerTableFields[index].tableId == this.name) {
        let fieldsJsonStr = this.store.state.customerTableFields[index].fieldsJson;
        if (fieldsJsonStr != '') {
          fieldsJson = JSON.parse(fieldsJsonStr);
        }
      }
    }
    if (fieldsJson != null) {
      this.columns.push(...fieldsJson);
    }

    if (window.localStorage.getItem('column_' + this.name)) {
      try {
        this.showColumns = JSON.parse(window.localStorage.getItem('column_' + this.name));
        //如果是后面增减任何列都没问题，但是xuanze要特定处理，因为xuanze列是不给拖动的，如果后面新增了不给拖动，那就不合理了。所以这里对xuanze列特殊处理
        //如果确定有xuanze列新增，那么把他放到this.showColumns

        for (var i = 0; i < this.columns.length; i++) {
          if (this.columns[i].label == 'xuanze') {
            if (this.showColumns.indexOf('xuanze') == -1) {
              this.showColumns.splice(0, 0, 'xuanze'); // 在b位置插入从a位置截取的元素
              break;
            }
          }
        }
      } catch (e) {
        window.localStorage.removeItem('column_' + this.name);
        this.showColumns = this.columns.map(item => {
          return item.label;
        });
      }
    } else {
      this.showColumns = this.columns.map(item => {
        return item.label;
      });
    }

    if (window.localStorage.getItem('sort_' + this.name)) {
      let sort_str = window.localStorage.getItem('sort_' + this.name);
      let sort_arr = JSON.parse(sort_str);
      this.changeTableSortAction({
        prop: sort_arr[0],
        order: sort_arr[1]
      });
    }

    //根据语言类型初始化dialogWidth1，2，3，labelWidth
    this.dialogWidths = {
      w1: {
        default: '502px', //482
        zh_CN: '502px',
        en_US: '502px'
      },
      w2: {
        default: '830px', //810
        zh_CN: '830px',
        en_US: '830px'
      }
    };
    this.dialogWidth = this.dialogWidths['w1']['default'];
    this.formLabelWidths = {
      default: '147px',
      zh_CN: '147px',
      en_US: '147px'
    };
    this.formLabelWidth = this.formLabelWidths['default'];

    this.utils.event_hub.$on('RESIZE', () => {
      setTimeout(() => {
        this.resetTableHeight();
        if (this.$refs['table'] != null) {
          this.$refs['table'].doLayout();
          this.buildSearchExpand();
        }
      }, 300);
    });
  },
  activated() {
    console.log('activated');
    this.buildSearchExpand();
  },
  mounted() {
    this.$parent.$set(this.$parent, 'isYiCurdLoaded', true);
    //延时是为了让搜索栏里面的自定义组件先加载完再计算搜索栏长度
    setTimeout(() => {
      this.buildSearchExpand();
    }, 100);
  },
  destroyed() { },
  computed: {
    //支持多个
    generateDictionayValues() {
      return (key, row, prop) => {
        let str = '';
        let valueKeys = this.utils.getObjValueByLevelString(row, prop);
        if (valueKeys instanceof Array) {
          for (var i = 0; i < valueKeys.length; i++) {
            if (i > 0) {
              str += ',';
            }
            str += this.$t(this.store.state.dictJsonAll[key][valueKeys[i]]);
          }
        } else {
          str = this.$t(this.store.state.dictJsonAll[key][valueKeys]);
        }
        return str;
      };
    },
    //带tag字典，只支持单个
    generateDictionayValueOne() {
      return (key, row, prop) => {
        let valueKey = this.utils.getObjValueByLevelString(row, prop);
        let str = this.$t(this.store.state.dictJsonAll[key][valueKey]);
        return str;
      };
    },
    generateDictionayColorOne() {
      return (key, row, prop) => {
        let valueKey = this.utils.getObjValueByLevelString(row, prop);
        let str = this.store.state.dictJsonAll[key + '_COLOR'][valueKey];
        return str;
      };
    },
    generateTransferColumns() {
      let columns = this.columns.map(item => {
        return {
          label: item.label,
          key: item.label,
          disabled: item.label == 'xuanze' ? true : false
        };
      });
      return columns;
    },
    generateTableColumns() {
      console.log(this.aaa);
      let table_columns = [];
      for (let i = 0; i < this.showColumns.length; i++) {
        let label = this.showColumns[i];
        let column = this.columns.find(item => {
          return item.label == label;
        });
        if (!column) {
          //当我们修改了代码，改变了label，跟本地的showColumns对不上的时候，就查询不到column出来了，就删掉他
          this.showColumns.splice(i, 1);
          window.localStorage.setItem('column_' + this.name, JSON.stringify(this.$parent.showColumns));
          continue;
        }
        table_columns.push(column);
      }
      //
      //自定义宽度
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + this.name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + this.name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + this.name);
        }
      }

      //这里要再弄一个fixShowColumnsLabel出来
      if (this.fixShowColumns.length > 0) {
        for (var i = 0; i < this.fixShowColumns.length; i++) {
          if (colwidths[this.$t(this.fixShowColumns[i].label)] != null) {
            this.fixShowColumns[i].width = colwidths[this.$t(this.fixShowColumns[i].label)];
          }
        }
        return this.fixShowColumns;
      }

      for (var i = 0; i < table_columns.length; i++) {
        if (colwidths[this.$t(table_columns[i].label)] != null) {
          table_columns[i].width = colwidths[this.$t(table_columns[i].label)];
        }
      }
      return table_columns;
    },
    //这个是生成fixShowColumns的label数组的，注意，是label
    generateFixShowColumns() {
      let table_columns = [];
      for (let i = 0; i < this.fixShowColumns.length; i++) {
        let label = this.fixShowColumns[i].label;
        table_columns.push(label);
      }

      return table_columns;
    },
    isSelected() {
      return id => {
        if (this.ids == null) {
          return false
        }
        return this.ids.indexOf(id) >= 0;
      };
    }
  },
  methods: {
    addRedStar(h, { column }) {
      // 给表头加必选标识
      return [
        h(
          'span',
          {
            style: 'color: red'
          },
          '*'
        ),
        h('span', ' ' + column.label)
      ];
    },
    initSelectInput(SELECT_ID, SELECT_TITLE, SELECT_URL, SELECT_RESULT_KEY) {
      this.SELECT_ID = SELECT_ID;
      this.SELECT_TITLE = SELECT_TITLE;
      this.SELECT_URL = SELECT_URL;
      this.SELECT_RESULT_KEY = SELECT_RESULT_KEY;
    },

    showEditDialog(action, row, width, beforeShowEditDialog) {
      if (row) {
        this.editObj = this.utils.copy(row);
      } else {
        this.editObj = {};
      }
      this.$set(this.editObj, 'action', action);
      this.$set(this.editObj, 'loading', false);
      if (width) {
        if (typeof width == 'number') {
          width = width + 'px';
        } else if (this.dialogWidths[width]) {
          width = this.dialogWidths[width][this.$i18n.locale] ? this.dialogWidths[width][this.$i18n.locale] : this.dialogWidths[width]['default'];
        } else {
          //这里是百分比
        }
      } else {
        width = this.dialogWidths['w1']['default'];
      }
      this.dialogWidth = width;
      Object.assign(this.editObj, this.fixEditObj);
      if (beforeShowEditDialog) {
        const result = beforeShowEditDialog(this.utils.copy(this.editObj));
        // 如果返回的是 Promise，等待它完成
        if (result && typeof result.then === 'function') {
          result.then(resolvedObj => {
            if (resolvedObj) {
              this.editObj = resolvedObj;
              this.isShowEditDialog = true;
            }
          }).catch(err => {
            console.error('beforeShowEditDialog error:', err);
          });
          return;
        } else {
          this.editObj = result;
        }
      }
      if (!this.editObj) {
        return;
      }
      this.isShowEditDialog = true;
    },
    getItem(row) {
      //迟点估计还要支持对象的嵌套层级
      let title = '';
      for (var i = 0; i < this.SELECT_TITLE.split(',').length; i++) {
        let select_titles = this.SELECT_TITLE.split(',')[i];

        if (i == 0) {
          title += this.utils.getObjValueByLevelString(row, select_titles);
        } else {
          title += ' | ' + this.utils.getObjValueByLevelString(row, select_titles);
        }
      }
      // console.log(this.utils.copy(row))

      this.$parent.$emit('getItem', this.utils.copy(row), row[this.SELECT_ID], title);
    },
    deleteItem(row) {
      // console.log(this.ids, row[this.SELECT_ID])
      this.$parent.$emit('deleteItem', this.ids.indexOf(row[this.SELECT_ID]));
    },
    getItemsByIds() {
      this.$nextTick(() => { });
      var params = {};
      params[this.SELECT_ID + 's'] = this.ids;
      this.http
        .get(this.SELECT_URL, {
          params: params
        })
        .then(result => {
          var items = result[this.SELECT_RESULT_KEY];
          var ids = [];
          var labels = [];

          for (var i = 0; i < items.length; i++) {
            ids.push(items[i][this.SELECT_ID]);

            //迟点估计还要支持对象的嵌套层级
            let title = '';
            for (var j = 0; j < this.SELECT_TITLE.split(',').length; j++) {
              let select_titles = this.SELECT_TITLE.split(',')[j];
              if (j == 0) {
                title += this.utils.getObjValueByLevelString(items[i], select_titles);
              } else {
                title += ' | ' + this.utils.getObjValueByLevelString(items[i], select_titles);
              }
            }

            labels.push(title);
          }

          this.$parent.$emit('getItemsByIds', items, ids, labels);
        })
        .catch(error => {
          console.log(error);
        });
    },
    clear(keep, beforeReq, afterReq) {
      this.conditions = keep ? this.utils.copy(keep) : {};
      this.get(1, beforeReq, afterReq);
    },

    get(pageNum, beforeReq, afterReq) {

      if (this.$attrs.isOnlyShowBack === true) {
        return
      }


      if (pageNum != null) {
        this.pageNum = pageNum;
      }
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.conditions,
        ...this.fixConditions
      };

      params = beforeReq ? beforeReq(params) : params;
      if (!params) {
        return;
      }
      delete params.form_param;
      this.loading = true;
      return this.http
        .get(this.getUrl, {
          params: params
        })
        .then(result => {
          if (afterReq) {
            //---------------这里目前有一个缺陷，就是分页的时候无法触发,看是否用一个全局变量来记录，或者说，不推荐修改元数据，完全可以在显示的时候再修改或者用computed------------------------------//
            result = afterReq(result);
          } else {
          }




          // this.utils.successMessage(result.msg)
          Object.keys(result['data']).forEach(key => {
            if (key == this.getKey) {
              this.list = result.data[this.getKey];
            } else if (key == 'total') {
              this.total = result.data.total;
            } else {
              this.$set(this.datas, key, result.data[key]);
            }
          });
          if (Array.isArray(result['data'])) {
            this.list = result.data
            this.total = this.list.length;

          }

          this.$emit('afterGet');
        })
        .catch(error => {
          this.list = [];
          this.total = 0;
          this.utils.errorMessage(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    beforeRemove(params) {
      return params;
    },
    remove(row, url, afterRemove, confirm) {
      this.$confirm(confirm ? confirm : this.$t('删除将不可恢复，是否继续?'), this.$t('WARNING'), {
        confirmButtonText: this.$t('delete'),
        cancelButtonText: this.$t('no'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;

            var params = {};
            params = this.utils.copy(row);
            params = this.beforeRemove(params);
            if (!params) {
              return;
            }
            this.http
              .post(url, params)
              .then(result => {
                if (afterRemove) {
                  afterRemove(result, done);
                } else {
                  //判断获取数量是否为空，并且pageNum>1,那么减一页然后重新查询
                  if (this.list.length == 1 && this.pageNum > 1) {
                    this.pageNum = this.pageNum - 1;
                  }
                  this.get();

                  instance.confirmButtonLoading = false;
                  done();
                  this.utils.successMessage(this.$t(result.msg));
                }

                this.$emit('finishRemove');
              })
              .catch(error => {
                instance.confirmButtonLoading = false;
                this.utils.errorMessage(this.$t(error));
              });
          } else {
            done();
          }
        }
      }).then(() => {
        //这里是执行confirm的done之后的
      });
    },

    // beforeReq(params, url) {
    // 	//临时用，理论上把这些组件改为字符串分割
    // 	return params
    // },
    // afterReq(result, url) {
    // 	//临时用，理论上把这些组件改为字符串分割
    // 	this.get(1)
    // 	return result
    // },

    req(method, url, beforeReq, afterReq, confirm) {
      var params = this.utils.copy(this.editObj);
      params = beforeReq ? beforeReq(params) : params;
      if (!params) {
        return;
      }
      delete params.form_param;

      if (confirm) {
        this.$confirm(this.$t(confirm), this.$t('WARNING'), {
          confirmButtonText: this.$t('queding'),
          cancelButtonText: this.$t('quxiao'),
          confirmButtonClass: 'el-button--danger',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;

              if (method == 'GET') {
                this.http
                  .get(url, {
                    params: params
                  })
                  .then(result => {
                    if (afterReq) {
                      afterReq(result);
                    } else {
                      this.get();
                      this.isShowEditDialog = false;
                    }
                    instance.confirmButtonLoading = false;
                    done();
                  })
                  .catch(error => {
                    instance.confirmButtonLoading = false;
                    this.utils.errorMessage(this.$t(error));
                  });
              } else if (method == 'POST') {
                this.http
                  .post(url, params)
                  .then(result => {
                    this.utils.successMessage(this.$t(result.msg));
                    if (afterReq) {
                      afterReq(result);
                    } else {
                      this.get();
                      this.isShowEditDialog = false;
                    }
                    instance.confirmButtonLoading = false;
                    done();
                  })
                  .catch(error => {
                    instance.confirmButtonLoading = false;
                    this.utils.errorMessage(this.$t(error));
                  });
              }
            } else {
              done();
            }
          }
        }).then(() => {
          //这里是执行confirm的done之后的
        });
      } else {
        if (method == 'GET') {
          this.$set(this.editObj, 'loading', true);

          this.http
            .get(url, {
              params: params
            })
            .then(result => {
              if (afterReq) {
                afterReq(result);
              } else {
                this.get();
                this.isShowEditDialog = false;
              }
            })
            .catch(error => {
              this.utils.errorMessage(this.$t(error));
            })
            .finally(() => {
              this.$set(this.editObj, 'loading', false);

            });
        } else if (method == 'POST') {
          this.$set(this.editObj, 'loading', true);

          this.http
            .post(url, params)
            .then(result => {
              this.utils.successMessage(this.$t(result.msg));
              if (afterReq) {
                afterReq(result);
              } else {
                this.get();
                this.isShowEditDialog = false;
              }
            })
            .catch(error => {
              this.utils.errorMessage(this.$t(error));
            })
            .finally(() => {
              this.$set(this.editObj, 'loading', false);
            });
        }
      }
    },

    upOrDown(row, key, url) {
      var params = {};
      params = this.utils.copy(row);
      if (params[key] == 'false') {
        params[key] = 'true';
      } else if (params[key] == 'true') {
        params[key] = 'false';
      } else {
        this.utils.errorMessage('参数异常');
        return;
      }
      this.http
        .post(url ? url : this.UPDOWN_URL, this.qs.stringify(params))
        .then(result => {
          this.utils.successMessage(result.msg);
          this.get();
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },

    selectable(row, index) {
      if (row.parentId == null) {
        return true;
      }
      if (row.parentId != null) {
        return this.isShowChildSelection;
      }
    },

    changeTableSort(sort_obj) {
      this.changeTableSortAction(sort_obj);
      this.get(1);
    },

    changeTableSortAction(sort_obj) {
      //根据prop取出sort,因为column并没有带上
      let sort = null;
      for (var i = 0; i < this.columns.length; i++) {
        // console.log(this.columns[i].prop)
        if (this.columns[i].prop == sort_obj.prop) {
          sort = this.columns[i].sort;
        }
      }
      if (sort == null) {
        return;
      }

      if (sort_obj.order) {
        this.conditions.order_property = sort;
        this.conditions.order_direction = sort_obj.order === 'ascending' ? 'asc' : 'desc';
        window.localStorage.setItem('sort_' + this.name, JSON.stringify([sort_obj.prop, sort_obj.order]));
      } else {
        delete this.conditions.order_property;
        delete this.conditions.order_direction;
        window.localStorage.removeItem('sort_' + this.name);
      }
    },

    showColumnsDialog() {
      this.isShowColumnsDialog = true;
      this.$nextTick(() => {
        this.initColumnsTransfer();
      });
    },
    showColumnsChange() {
      //保存
      window.localStorage.setItem('column_' + this.name, JSON.stringify(this.showColumns));
    },
    setColumnsShow(labels) {
      setTimeout(() => {

        for (let index = 0; index < labels.length; index++) {
          const label = labels[index];
          if (this.showColumns.indexOf(label) == -1) {
            this.showColumns.push(label)
          }
        }
        window.localStorage.setItem('column_' + this.name, JSON.stringify(this.showColumns));
      }, 0);

    },
    setColumnsHide(labels) {

      setTimeout(() => {
        for (let index = 0; index < labels.length; index++) {
          const label = labels[index];
          if (this.showColumns.indexOf(label) != -1) {
            this.showColumns.splice(this.showColumns.indexOf(label), 1)
            index--
          }
        }
        window.localStorage.setItem('column_' + this.name, JSON.stringify(this.showColumns));
      }, 0);


    },
    closeColumnsDialog(done) {
      //如果重置xuanze的数组，transfer框不会变动，导致后面index对不上,所以改为关闭弹框的时候重置
      for (var i = 0; i < this.showColumns.length; i++) {
        if (this.showColumns[i] === 'xuanze') {
          this.showColumns.splice(0, 0, this.showColumns.splice(i, 1)[0]); // 在b位置插入从a位置截取的元素
          break;
        }
      }
      this.showColumnsChange();
      done();
    },
    initColumnsTransfer() {
      const transfer = this.$refs.transfer.$el;
      const leftPanel = transfer.getElementsByClassName('el-transfer-panel')[0].getElementsByClassName('el-transfer-panel__body')[0];
      const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0];
      const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0];
      Sortable.create(rightEl, {
        animation: 100,
        filter: '.ignore-elements',
        onEnd: evt => {
          const { oldIndex, newIndex } = evt;

          const temp = this.showColumns[oldIndex];
          if (!temp || temp === 'undefined') {
            return;
          } // 解决右边最后一项从右边拖左边，有undefined的问题
          //这里和网上的有点不一样,网上搜到的结果排序是,当前拖拽的元素和拖拽位置的元素互换位置,但是实际上在使用el-transfer有两个问题
          //1.右侧排序value的数组顺序来源于后台穿的数组顺序,实际如果不设置target-order="unshift"的话,展示会按照左侧的数据列顺序展示,导致拖拽排序时顺序乱七八糟
          //2.实际拖拽排序看到的效果是当前拖拽元素拖拽到其他地方,其他地方的元素会下移,而不是调换顺序
          // 去除空字符串
          for (var i = 0; i < this.showColumns.length; i++) {
            if (this.showColumns[i] === '' || this.showColumns[i] === null || typeof this.showColumns[i] === 'undefined') {
              this.showColumns.splice(i, 1);
              i = i - 1;
            }
          }
          const arr_temp = [].concat(this.showColumns); // 创建一个新的临时数组，用以操作后不变更原数组
          arr_temp.splice(newIndex, 0, arr_temp.splice(oldIndex, 1)[0]); // 在b位置插入从a位置截取的元素

          this.showColumns = arr_temp;

          //保存
          this.showColumnsChange();
        }
      });
      const leftEl = leftPanel.getElementsByClassName('el-transfer-panel__list')[0];
      Sortable.create(leftEl, {
        animation: 100,
        onEnd: evt => {
          const { oldIndex, newIndex } = evt;

          this.$set(this.datas, oldIndex, this.datas[newIndex]);
          this.$set(this.datas, newIndex, temp);
        }
      });
      leftPanel.ondragover = ev => {
        ev.preventDefault();
      };
      leftPanel.ondrop = ev => {
        ev.preventDefault();

        const index = this.showColumns.indexOf(this.draggingKey);
        if (index !== -1) {
          this.showColumns.splice(index, 1);
        }
      };
      rightPanel.ondragover = ev => {
        ev.preventDefault();
      };
      rightPanel.ondrop = ev => {
        ev.preventDefault();

        if (this.showColumns.indexOf(this.draggingKey) === -1) {
          this.showColumns.push(this.draggingKey);
        }
      };
    },
    drag(ev, option) {
      this.draggingKey = option.key;
    },

    expandSearch() {
      this.isSearchHidden = !this.isSearchHidden;
      this.buildSearchExpand();
      setTimeout(() => {
        this.resetTableHeight();
      }, 300);
    },

    exportExcel(file_name = 'sheetjs', id = this.randKey) {
      let saveColumns = this.utils.deepCopy(this.columns);



      //先把所有fixed去掉
      for (var i = 0; i < this.columns.length; i++) {
        this.columns[i].fixed = false;
      }

      return new Promise(resolve => {
        this.isExportExcelt = true;
        this.loading = true;
        setTimeout(() => {
          /* 从表生成工作簿对象，加上raw就是单元格统一为string */
          var wb = XLSX.utils.table_to_book(document.querySelector('#' + id), {
            raw: true
          });

          // 删除表头为 'xuanze'、'caozuo' 或空字符串的列
          const xuanzeText = this.$t('xuanze');
          const caozuoText = this.$t('caozuo');
          const sheetName = wb.SheetNames[0];
          const sheet = wb.Sheets[sheetName];

          if (sheet) {
            // 获取工作表的范围
            const range = XLSX.utils.decode_range(sheet['!ref'] || 'A1');

            // 找出需要删除的列索引
            const columnsToDelete = [];
            for (let col = range.s.c; col <= range.e.c; col++) {
              const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col }); // 第一行（表头行）
              const cell = sheet[cellAddress];
              let headerText = '';
              if (cell && cell.v) {
                headerText = cell.v.toString().trim();
              }
              // 删除表头为 'xuanze'、'caozuo' 或空字符串的列
              if (headerText === xuanzeText || headerText === caozuoText || headerText === '') {
                columnsToDelete.push(col);
              }
            }

            // 从后往前删除列，避免索引变化影响
            columnsToDelete.sort((a, b) => b - a);
            for (let colIndex of columnsToDelete) {
              // 删除该列的所有单元格
              for (let row = range.s.r; row <= range.e.r; row++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
                delete sheet[cellAddress];
              }

              // 将后面的列向前移动
              for (let col = colIndex + 1; col <= range.e.c; col++) {
                for (let row = range.s.r; row <= range.e.r; row++) {
                  const oldAddress = XLSX.utils.encode_cell({ r: row, c: col });
                  const newAddress = XLSX.utils.encode_cell({ r: row, c: col - 1 });
                  if (sheet[oldAddress]) {
                    sheet[newAddress] = sheet[oldAddress];
                    delete sheet[oldAddress];
                  }
                }
              }
              range.e.c--; // 更新范围
            }

            // 更新工作表的范围
            if (range.e.c >= range.s.c) {
              sheet['!ref'] = XLSX.utils.encode_range(range);
            }
          }

          /* 获取二进制字符串作为输出 */
          var wbout = XLSX.write(wb, {
            bookType: 'xlsx',
            bookSST: true,
            type: 'array'
          });
          try {
            FileSaver.saveAs(
              //Blob 对象表示一个不可变、原始数据的类文件对象。
              //Blob 表示的不一定是JavaScript原生格式的数据。
              //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
              //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
              new Blob([wbout], {
                type: 'application/octet-stream'
              }),
              //设置导出文件名称
              file_name + '.xlsx'
            );
          } catch (e) {
            if (typeof console !== 'undefined') console.log(e, wbout);
          }

          this.columns = saveColumns;
          this.loading = false;
          this.isExportExcelt = false;
          resolve(wbout);
        }, 300);
      });
    },

    buildSearchExpand() {
      if (!this.isShowCondition) {
        return;
      }

      let conditions = this.$refs.conditions;

      let form = conditions.getElementsByTagName('form')[0];
      if (!form) {
        return;
      }
      //先解除所有
      for (var i = 0; i < form.getElementsByClassName('el-form-item el-form-item--mini').length; i++) {
        let item = form.getElementsByClassName('el-form-item el-form-item--mini')[i];
        item.classList.remove('hideFormItem');
      }

      //再在下一帧计算
      this.$nextTick(() => {
        //每次都加上最后的搜索栏先
        let length = form.getElementsByClassName('el-form-item el-form-item--mini').length;
        if (form.getElementsByClassName('el-form-item el-form-item--mini')[length - 1] == null) {
          return;
        }
        let width = form.getElementsByClassName('el-form-item el-form-item--mini')[length - 1].getBoundingClientRect().width + 10;
        for (var i = 0; i < length - 1; i++) {
          let item = form.getElementsByClassName('el-form-item el-form-item--mini')[i];
          width += item.getBoundingClientRect().width + 10;
          if (width <= conditions.getBoundingClientRect().width) {
          } else {
            //如果隐藏，则隐藏
            if (this.isSearchHidden) {
              item.classList.add('hideFormItem');
            }
          }
        }
        //如果超长，显示按钮

        if (width > conditions.getBoundingClientRect().width) {
          this.isSearchNeedHide = true;
        } else {
          this.isSearchNeedHide = false;
        }
      });
    },
    textareaFold() {
      // this.$nextTick(() => {
      // 	this.$refs['table'].doLayout();
      // 	alert(11);
      // });
    },
    sizeChange(val) {
      this.pageSize = val; //动态改变
      this.get(1);
    },
    listChange() {
      if (this.isRandKey) {
        this.randKey = 't' + new Date().valueOf(); //selector首个字母不能数字，所以加个t
      }
      this.$nextTick(() => {
        this.resetTableHeight();

        if (window.localStorage.getItem('sort_' + this.name)) {
          let sort_str = window.localStorage.getItem('sort_' + this.name);
          let sort_arr = JSON.parse(sort_str);

          //randkey改变会清除排序样式，但是数值不变,所以这里单纯改变样式。而这里不用方法来改变排序，用循环来改变，是因为用方法改变会触发回调，回调里面get，get又会触发listChange,死循环。
          this.$refs.table.columns.forEach(item => {
            // console.log(item);
            if (item.property == sort_arr[0]) {
              item.order = sort_arr[1];
            }
          });
        }

        this.resetSelectedIds();
      });
    },
    resetTableHeight() {

      if (this.isSetTableHeightAuto) {
        // this.tableHeight = null
        return
      }



      if (this.$refs.container && this.$refs.footer && this.$refs.header) {
        setTimeout(() => {
          this.tableHeight = (this.fixContainerHeight == 0 ? this.$refs.container.offsetHeight : this.fixContainerHeight) - this.$refs.footer.offsetHeight - this.$refs.header.offsetHeight - 20 - 10;
        }, 0);
      }
    },
    // columnUp(e, label) {
    // 	e.preventDefault()
    // 	alert(label)
    // }
    changeTableSort(e) {
      //用来重载
    },
    getSummaries(e) {
      //用来重载
    },
    sortMethod(col) {
      return (a, b) => {
        let aValue = this.utils.getObjValueByLevelString(a, col.prop);
        let bValue = this.utils.getObjValueByLevelString(b, col.prop);
        if (col.sort == 'number') {
          return aValue - bValue;
        } else if (col.sort == 'datetime') {
          let reg1 = new RegExp(' ', 'g');
          let reg2 = new RegExp('-', 'g');
          let reg3 = new RegExp(':', 'g');
          return (
            aValue
              .replace(reg1, '')
              .replace(reg2, '')
              .replace(reg3, '') -
            bValue
              .replace(reg1, '')
              .replace(reg2, '')
              .replace(reg3, '')
          );
        } else {
          return (aValue + '').localeCompare(bValue + '') > 0 ? -1 : 1;
        }
      };
    },
    headerDragend(newWidth, oldWidth, column, event) {
      if (!this.name) {
        alert(this.$t('biaogemingchengweikong'));
        return;
      }
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + this.name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + this.name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + this.name);
        }
      }
      if (column.label == '' || column.label == null) {
        return;
      }
      colwidths[column.label] = column.width;
      window.localStorage.setItem('colwidth_' + this.name, JSON.stringify(colwidths));
      this.aaa = !this.aaa;
    },
    // toggleSelection(rows) {
    //         if (rows) {
    //           rows.forEach(row => {
    //             this.$refs.multipleTable.toggleRowSelection(row);
    //           });
    //         } else {
    //           this.$refs.multipleTable.clearSelection();
    //         }
    //       },
    resetSelectedIds() {
      this.list.forEach(row => {
        if (this.isSelected(row[this.SELECT_ID])) {
          this.$refs.table.toggleRowSelection(row, true);
        } else {
          this.$refs.table.toggleRowSelection(row, false);
        }
      });
    },
    rowClick(row) {
      if (this.ids != null) {
        if (this.selectable(row) == true) {
          if (this.isSelected(row[this.SELECT_ID])) {
            this.deleteItem(row);
          } else {
            this.getItem(row);
          }
          this.resetSelectedIds();
        }
      } else {
        if (this.columns[0].selectable == null || this.columns[0].selectable(row) == true) {
          this.$refs.table.toggleRowSelection(row);
        }
      }
      this.$emit('rowClick', row);
    },
    select(e, row) {
      if (this.ids != null) {
        if (this.isSelected(row[this.SELECT_ID])) {
          this.deleteItem(row);
        } else {
          this.getItem(row);
        }
        this.resetSelectedIds();
      } else {
        this.$emit('select', e);
      }
    },
    selectAll(e) {
      if (this.ids != null) {
        if (e.length == 0) {
          for (var i = 0; i < this.list.length; i++) {
            this.deleteItem(this.list[i]);
          }
        } else {
          let current = this.ids.length;
          for (var i = 0; i < this.list.length; i++) {
            if (this.ids.indexOf(this.list[i][this.SELECT_ID]) == -1) {
              current += 1;
            }
          }
          if (current >= this.max) {
            this.utils.errorMessage(this.$t('chaoguozuidakexuanshuliang'));
          } else {
            for (var i = 0; i < this.list.length; i++) {
              this.getItem(this.list[i]);
            }
          }
        }
        this.resetSelectedIds();
      } else {
        this.$emit('selectAll', e);
      }
    },
    selectionChange(e) {
      if (this.ids != null) {
      } else {
        this.$emit('selectionChange', e);
      }
    }
  },
  watch: {
    ids(n, o) {
      this.resetSelectedIds();
    },
    isShowEditDialog(n, o) {
      if (this.isShowEditDialog == true) {
      } else {
        setTimeout(() => {
          this.$set(this.editObj, 'action', '');
        }, 300);
      }
    },

    list(n, o) {
      this.listChange();
    }
  }
};
</script>
